import { render, staticRenderFns } from "./ThgBillingSelectionItemSendMailDialog.vue?vue&type=template&id=2c144b94&"
import script from "./ThgBillingSelectionItemSendMailDialog.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingSelectionItemSendMailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports